/**
 * Authentication API service
 * @module api/auth
 */
import api from './axios';

/**
 * Login user
 * @param {Object} data - Login credentials
 * @param {string} data.username - Username
 * @param {string} data.password - Password
 * @returns {Promise<Object>} Response data
 */
export const login = (data) => api.post('/auth/login', data);

/**
 * Register user
 * @param {Object} data - User data
 * @param {string} data.username - Username
 * @param {string} data.password - Password
 * @param {string} data.name - Name
 * @param {string} data.email - Email
 * @param {string} data.role - Role (optional)
 * @returns {Promise<Object>} Response data
 */
export const register = (data) => api.post('/auth/register', data);

/**
 * Get current user
 * @returns {Promise<Object>} Response data
 */
export const getCurrentUser = () => api.get('/auth/me');
